<ul>
  <li>
    <p style="margin-bottom:10px;">
      <span style=""
        ><span style="color: #00b0f0;"><span style=""><span lang="en-GB"><strong>Target</strong></span></span></span><span
          style="color: #00b0f0;"><span style=""><span lang="en-GB">: </span></span></span
        ><span style="color: #404040;"
          ><span style=""
            ><span lang="en-GB"
              >Revenue/cost/EBITDA target YTD (in &euro;). If reporting timeframe is a previous year: target for the selected year.</span
            ></span
          ></span
        ></span
      >
    </p>
  </li>
  <li>
    <p style="margin-bottom:10px;">
      <span style=""
        ><span style="color: #404040;"><span style=""><span lang="en-GB"><strong>Actual</strong></span></span></span><span
          style="color: #404040;"
          ><span style=""
            ><span lang="en-GB"
              >: Cumulative actual revenue/costs/EBITDA YTD (in &euro;). If reporting timeframe is a previous year: Actual annual
              revenue/costs/EBITDA of the selected year.</span
            ></span
          ></span
        ></span
      >
    </p>
  </li>
  <li>
    <p>
      <span style="color: #92d050;">●</span><span style=""
        ><span style="color: #404040;"><span style=""><span lang="en-GB">/</span></span></span><span style="color: #ffc000;"
          ><span lang="en-GB"><strong>●</strong></span></span
        ><span style="color: #404040;"
          ><span style=""><span lang="en-GB">: The icon indicates whether the target is met (</span></span></span
        ><span style="color: #92d050;"><span lang="en-GB"><strong>●</strong></span></span><span style="color: #404040;"
          ><span style=""><span lang="en-GB">) or missed (</span></span></span
        ><span style="color: #ffc000;"><span lang="en-GB"><strong>●</strong></span></span><span style="color: #404040;"
          ><span style=""><span lang="en-GB">)</span></span></span
        ></span
      >
    </p>
  </li>
</ul>
<p lang="en-GB">&nbsp;</p>
<p>Chart:</p>
<p>
  &nbsp; &nbsp; <img
    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAHCAYAAADnCQYGAAAAZklEQVR4nGP5/PWLABALMQDB79+/2X/++snFAAVfv3/j//fvPxOI/ffvH9bvP3/wwOS+f//O+/ffXxaw3L9/zN++f+eDybFs2b8zY97qJe0MVAQs1DSMtoZyc3J9pLqh1DaQZoYCAGLFKbUl7JYmAAAAAElFTkSuQmCC"
    alt=""
  />&nbsp; Revenue per month/quarter (selected year)
</p>
<p>
  &nbsp; &nbsp; <img
    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAADCAYAAADRGVy5AAAAc0lEQVR4nGO5cP2yw5nL5z0YiADcXNwfIryDOvCpOXbuZMD1u7csiDFPkF/wRZCbzwR8ag6cPBJx99F9A0JmsYAsXbl1fTkxFosJizwi5JGzVy66bd63I5MY8xRl5C8T8siJ86d99504HEXILBZiLBwKAACQKiqi/wJKIAAAAABJRU5ErkJggg=="
    alt=""
  />&nbsp; &nbsp;Cost per month/quarter (selected year)
</p>
<p>
  &nbsp; &nbsp; <img
    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAHCAYAAABtJp9HAAAAOElEQVR4nGM5/uCjxcE7H+0ZBgiwMDP+4WVn/sxy4M4Hh8ot99sHyiFwBw20A2Bg1CHoYNQh6AAA+OkNJwZ8Xq0AAAAASUVORK5CYII="
    alt=""
  />&nbsp; EBITDA per month/quarter (selected year)
</p>
<p>
  &nbsp; &nbsp; <img
    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAHCAYAAAAf6f3xAAAAKUlEQVR4nGN5//69w7t37zwY6AxYPn36ZPHo0aNyultMbwtHLR45FgMAxS8MZ2DF4vYAAAAASUVORK5CYII="
    alt=""
  />&nbsp; Revenue per month/quarter of prev. year
</p>
<p>
  &nbsp; &nbsp; <img
    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAAAICAYAAACxggIoAAABF0lEQVR4nN1WS2rDMBCNpDGJ8mmMvfdxcqbcIOQ6hUCXPYS39cLbgFtCEvKxpb4BqXjTkIUiSB4IjzSPeRpZMzZZawevAuRCXdfN/Lxt2znWJNvGGI0xcjwF3luPx7ZyvBF82rkkx2BDa/1FbMA5RoChFwThTxC+uwV5zQsy17kEfCkbWZZ9pGn6GepwmqZZlGX5Dq1hqJj/Ic/zDdV1vayqavVoMYZSah/ysIQQJsZBeVAsIQZu4iRkPCnlKWS8W+DKIbydNpbgk0MQSuMQS833u1CIuXfux1HLMHR/iVkVaCFTiln3SC7of0qSJNuiKNZ+TkTf3uZbB70L28jxyh+XHu8HD+t8R4yz218H3q7H2/Ga451+Abuclk+cJU9FAAAAAElFTkSuQmCC"
    alt=""
  />&nbsp; Cost per month/quarter of prev. year
</p>
<p style="margin-bottom:10px;">
  &nbsp; &nbsp; <img
    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAALCAYAAACksgdhAAAAJUlEQVR4nGP58/cf87ff/7gYSAAsIA0Xnn4xIEkTKYpHNQ0tTQCj+Qvyci0f2AAAAABJRU5ErkJggg=="
    alt=""
  />&nbsp; EBITDA per month/quarter of prev. year
</p>

<!-- <p style="margin-bottom:10px;">&nbsp; &nbsp; <img style=" width:10px; height:2px;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAABCAYAAAAFKSQHAAAAFElEQVR4nGP58/cf87ff/7gYSAAAJHkF+ChzuMIAAAAASUVORK5CYII=" alt="" />&nbsp; EBITDA per month/quarter of prev. year</p> -->
<style>
  p {
    padding: 0;
    margin: 0;
  }

  img {
    width: 11px;
    height: 2px;
  }
</style>
